export default {
    "name": "LoadArbitraryChartData",
    "kind": "HoudiniQuery",
    "hash": "370fae497ba955a75c18f5da154ed1221c7f54802652ff05e9a05b373787cf27",

    "raw": `query LoadArbitraryChartData($input: LoadArbitraryChartDataInput!) {
  loadArbitraryChartData(input: $input)
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "loadArbitraryChartData": {
                "type": "String",
                "keyRaw": "loadArbitraryChartData(input: $input)",
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "LoadArbitraryChartDataInput"
        },

        "types": {
            "DashboardReportParameterDates": {
                "from": "String",
                "to": "String"
            },

            "DashboardReportParameterSelectionInput": {
                "dates": "DashboardReportParameterDates",
                "name": "String",
                "value": "String"
            },

            "LoadArbitraryChartDataInput": {
                "chart": "String",
                "parameterSelectionList": "DashboardReportParameterSelectionInput"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=ca202c0c843497e0784d15d954ac22a226a6c92d6d111ee151aa14cc43e74f60";